import 'reflect-metadata';
import './fix'
import { createApp } from 'vue'
import router from './routers'
import App from './App.vue'
import './assets/style/main.scss'
import '@patsnap-biz/design-tokens/scss/_variables-RD.css';
import { startup } from '@eureka/startup'
import { i18n } from '@/infrastructure/locales'
import { container } from './inversify.config';
import { setContainer, injectService } from '@patsnap/tahiti-core/ioc/inject';
import { HeaderServiceProxy } from './services/header-service-proxy'
import { ErrorHandler } from '@patsnap/tahiti-core/common/error-handler';
import { ErrorHandlerRegistry } from '@patsnap/tahiti-core/common/error-handler-contribution';
import { AnonymousError } from '@eureka/services/src/exception';
import { accountDeferred } from '@eureka/utils/account';
import type { LoginDialogService } from './domains/shared/services/login-dialog-service';
import { injectFingerprintInterceptor } from '@eureka/services/src/apis/interceptors/fingerprint.interceptor';
import { SafeHtmlPlugin } from '@eureka/shared/safe-html-plugin';
import { UsageAmountWhere } from '@eureka/shared/edition-upgrade/src/constants';
setContainer(container);
injectService<ErrorHandler>(ErrorHandler).onStart();
injectService<ErrorHandlerRegistry>(ErrorHandlerRegistry).onStart();
injectFingerprintInterceptor();

const app = createApp(App);
app.config.throwUnhandledErrorInProduction = true;
app.use(router).use(i18n).use(SafeHtmlPlugin).mount('#app')

const headerServiceInstance = injectService<HeaderServiceProxy>(HeaderServiceProxy).headerService as HeaderServiceProxy['headerService'];

accountDeferred.promise.then(
    () => {
        import('@eureka/startup/src/help-center').then(({ getHelpCenter }) => {
            getHelpCenter(i18n.global, headerServiceInstance)
        })
    }
);

// 配置数组,可以根据需要进行修改
const detailPageRegExps = [
    /\/result/
];

// 判断是否为详情页面 (Triz使用hash路由,需要检查hash而非pathname)
const isSeekDetailPage = () => {
    const currentPath = window.location.hash.replace(/^#/, '');
    return detailPageRegExps.some(pathReg => pathReg.test(currentPath));
};

startup({
    headerService: headerServiceInstance,
    projectName: 'eureka',
    agentName: UsageAmountWhere.TRIZ,
    preset: {
        name: 'eureka',
        preRedirectLogin() {
            const isSkipPage = isSeekDetailPage() && !headerServiceInstance?.userCenterService?.logged
            if (!isSkipPage) {
                Promise.all([
                    import('./domains/shared/services/login-dialog-service'),
                    import('./container-modules/login-dialog-module')
                ]).then(([{ LoginDialogService }, { loginDialogModule }]) => {
                    if (!container.isBound(LoginDialogService)) {
                        container.load(loginDialogModule);
                    }
                    const loginDialogService = injectService<LoginDialogService>(LoginDialogService);
                    loginDialogService.open();
                });
            }
            throw new AnonymousError();
        },
    },
    pageInit() {
        return Promise.resolve()
    },
});
